export default __webpack_public_path__ + "static/media/TRM.f1ea0f29.png";